'use client';

import { c as _c } from "react/compiler-runtime";
import 'swiper/css';
import { FC, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper/types';
import { SlideItem } from '@/components/Hero/types';
import Slide from './Slide';
import css from './style.module.scss';
interface Props {
  items: SlideItem[];
}
const AUTO_SLIDE_INTERVAL = 15000;
const AUTO_SLIDE_SPEED = 2000;
const CustomSlider: FC<Props> = t0 => {
  const $ = _c(17);
  const {
    items: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  const swiperRef = useRef(null);
  const autoSlideTimerRef = useRef(null);
  const lastInteractionRef = useRef(0);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (!swiperRef.current) {
        return 1;
      }
      const swiper = swiperRef.current;
      const slides = swiper.slides;
      const swiperWidth = swiper.width;
      const activeIndex = swiper.activeIndex;
      let visibleCount = 0;
      let accumulatedWidth = 0;
      for (let i = activeIndex; i < slides.length; i = i + 1, i) {
        const slideWidth = slides[i].offsetWidth;
        if (accumulatedWidth + slideWidth <= swiperWidth) {
          visibleCount = visibleCount + 1;
          accumulatedWidth = accumulatedWidth + slideWidth;
        } else {
          break;
        }
      }
      return Math.max(1, visibleCount);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const calculateVisibleSlidesCount = t3;
  let t4;
  if ($[3] !== items.length) {
    t4 = () => {
      if (autoSlideTimerRef.current) {
        clearInterval(autoSlideTimerRef.current);
      }
      autoSlideTimerRef.current = setInterval(() => {
        const timeSinceLastInteraction = Date.now() - lastInteractionRef.current;
        if (timeSinceLastInteraction >= AUTO_SLIDE_INTERVAL && swiperRef.current) {
          const swiper_0 = swiperRef.current;
          const visibleCount_0 = calculateVisibleSlidesCount();
          const currentReal = swiper_0.realIndex;
          const targetReal = (currentReal + visibleCount_0) % items.length;
          swiper_0.slideToLoop(targetReal, AUTO_SLIDE_SPEED);
        }
      }, 1000);
    };
    $[3] = items.length;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const resetAutoSlideTimer = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      lastInteractionRef.current = Date.now();
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleUserInteraction = t5;
  let t6;
  if ($[6] !== resetAutoSlideTimer) {
    t6 = () => {
      lastInteractionRef.current = Date.now();
      resetAutoSlideTimer();
      return () => {
        if (autoSlideTimerRef.current) {
          clearInterval(autoSlideTimerRef.current);
        }
      };
    };
    $[6] = resetAutoSlideTimer;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  useEffect(t6, t7);
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = swiper_1 => {
      window.swiper1 = swiper_1;
      swiperRef.current = swiper_1;
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== items) {
    t9 = items.map(_temp);
    $[10] = items;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== items) {
    t10 = items.map(_temp2);
    $[12] = items;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <Swiper loop={true} grabCursor={true} slidesPerView="auto" spaceBetween={0} speed={AUTO_SLIDE_SPEED} className={css.swiperContainer} onSlideChange={handleUserInteraction} onTouchStart={handleUserInteraction} onTouchMove={handleUserInteraction} onSwiper={t8}>{t9}{t10}</Swiper>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};
export default CustomSlider;
function _temp(t0) {
  const {
    id,
    image
  } = t0;
  return <SwiperSlide key={id} className={css.swiperSlide}><Slide image={image} /></SwiperSlide>;
}
function _temp2(t0) {
  const {
    id: id_0,
    image: image_0
  } = t0;
  return <SwiperSlide key={id_0} className={css.swiperSlide}><Slide image={image_0} /></SwiperSlide>;
}